<template>
    <div class="aftermarket">
        <navbar></navbar>
        <div class="box-header">
            <h1 class="box-title">{{$t('Order_return_exchange_type1')}} / {{$t('Order_return_exchange_type2')}}</h1>
        </div>
        <div class="order-sn">{{$t('user_center_order_order_num')}}: <span>{{$route.params.order_sn}}</span></div>
        <listing :lists="orders"></listing>
        <hr>
        <div class="form-list" v-if="type === 'a' ">
            <div class="form-group">
                <label>{{$t('Order_return_exchange_type')}}</label>
                <div class="form-control">
                    <label class="profile-radio" @click="setServiceType(1)">
                        <span class="pro-radio" v-bind:class="{'pro-radio-checked':serviceType==1}">
                            <span class="pro-radio-inner"></span>
                            <input type="radio" class="pro-radio-input">
                        </span>
                        <span>{{$t('Order_return_exchange_type1')}}</span>
                    </label>
                    <label class="profile-radio" @click="setServiceType(2)">
                        <span class="pro-radio" v-bind:class="{'pro-radio-checked':serviceType==2}">
                            <span class="pro-radio-inner"></span>
                            <input type="radio" class="pro-radio-input">
                        </span>
                        <span>{{$t('Order_return_exchange_type2')}}</span>
                    </label>
                </div>
            </div>
            <div class="form-group">
                <label>{{$t('Order_return_exchange_logistics_state')}}</label>
                <div class="form-control">
                    <label class="profile-radio" @click="setExpressStatus(1)">
                        <span class="pro-radio" v-bind:class="{'pro-radio-checked':expressStatus==1}">
                            <span class="pro-radio-inner"></span>
                            <input type="radio" class="pro-radio-input">
                        </span>
                        <span>{{$t('Order_return_exchange_logistics_state_1')}}</span>
                    </label>
                    <label class="profile-radio" @click="setExpressStatus(2)">
                        <span class="pro-radio" v-bind:class="{'pro-radio-checked':expressStatus==2}">
                            <span class="pro-radio-inner"></span>
                            <input type="radio" class="pro-radio-input">
                        </span>
                        <span>{{$t('Order_return_exchange_logistics_state_2')}}</span>
                    </label>
                </div>
            </div>
            <div class="form-group" v-if="serviceType == 1">
                <label>{{$t('Order_return_exchange_amount')}}</label>
                <div class="form-control">
                    <p class="text-error">{{orders[0].goods_unit}} {{orders[0].goods_price * orders[0].goods_num}}</p>
                </div>
            </div>
            <div class="form-group" style="margin-top: 20px;">
                <label v-if="serviceType == 1">{{$t('Order_return_exchange_explain')}}</label>
                <label v-if="serviceType == 2">{{$t('Order_return_exchange_description')}}</label>
                <select class="return_select" v-model="selected"  @change="handleChange()" id="test">
                    <option  :key="index" v-for="(option,index) in options" v-bind:value="option.value" v-bind:data="index" ref="selected">
                        {{ option.text }}
                    </option>
                </select>
            </div>
            <div class="form-group" v-if="other">
                <textarea :placeholder="$t('user_message_please_input_recharge')" cols="60" rows="5" v-model="explanation" style="margin-top: 15px;"></textarea>
            </div>
            <div class="tips">
                <p>{{$t('return_tips_title')}}</p>
                <p>{{$t('return_tips_content')}}</p>
            </div>
            <div class="form-submit">
                <button class="btn btn-primary btn-big" @click="submit">{{$t('Submit_btn')}}</button>
            </div>
        </div>
        <div v-else-if="type === 'b' ">
            <div class="form-group" >
                <label>{{$t('Order_return_exchange_logistics_state')}}:</label>
                <div class="form-control">
                    <p>{{typeName}}</p>
                </div>
            </div>
            <div class="form-group" >
                <label>{{$t('Order_return_exchange_amount')}}：</label>
                <div class="form-control">
                    <p class="text-error">{{orders[0].goods_unit}}{{orders[0].goods_price * orders[0].goods_num}}</p>
                </div>
            </div>
            <div class="form-group" v-if="serviceType == 1">
                <label>{{$t('Order_return_exchange_explain')}}：</label>
                <div class="form-control">
                    <p>{{explanation || service_list.explanation}}</p>
                </div>
            </div>
            <div class="form-group" >
                <label>{{$t('Order_return_exchange_status')}}：</label>
                <div class="form-control">
                    <span>{{serviceStatusName}}</span>
                    <a class="text-primary" @click="openCanceled = true"
                       v-if="service_list.service_status !=9 || service_list.service_status !=3">{{$t('Order_return_exchange_Cancellation')}}</a>
                </div>
            </div>
            <model v-model="openCanceled" @on-ok="canceled" :title="$t('Order_return_exchange_Cancellation')" style="text-align: center">
                <div style="padding: 20px">
                    {{$t('Order_return_exchange_Cancellation_tip')}}
                </div>
            </model>
        </div>
    </div>
</template>
<script>
    import navbar from '../../components/Common/Navbar.vue'
    import Signature from '../../lib/Signature'
    import listing from '../../components/MyDetails/Common/Listing.vue'
    import model from '../../components/Common/Modal.vue'

    export default {
        data () {
            return {
                selected: 1,
                options: [
                    { text: this.$t('return_problem1'),value:1},
                    { text: this.$t('return_problem2'),value:2},
                    { text: this.$t('return_problem3'),value:3},
                    { text: this.$t('return_problem4'),value:4},
                    { text: this.$t('return_problem5'),value:5},
                    { text: this.$t('return_problem6'),value:6},
                ],
                orders: [0],
                data:'',
                options_g:this.$t('return_problem1'),
                other:false,
                order_info: {},
                process_result_yes:'',
                serviceType: 1,
                expressStatus: 1,
                service_list: {},
                after_id:0,
                explanation: '',
                service_status: 1,
                openCanceled: false,
                type: ''
            }
        },
        watch:{
            '$route':(to, from, next) =>{
                console.log(to.query)
            }
        },
        computed: {
            serviceStatusName () {
                if (this.service_list.service_status === 1) {
                    return ""+ this.$t('Order_return_exchange_pending') +""
                } else if (this.service_list.service_status === 9) {
                    return ""+ this.$t('Order_return_exchange_revoked') +""

                } else if (this.service_list.service_status === 3){
                    return ""+ this.service_list.process_result
                }
                return ""+ this.$t('Order_return_exchange_pending') +""
            },
            typeName () {
                if (this.serviceType === 1) {
                    return " "+ this.$t('Order_return_exchange_type1') +" "
                } else {
                    return " "+ this.$t('Order_return_exchange_type2') +" "
                }
            },
            hasExpressStatus () {
                if (this.service_list !== null) {
                    return true
                }
                return false
            }
        },
        components: {
            navbar, listing, model
        },
        created () {
            this.fetchData()
            this.getRecharge()
            if( this.$route.query.after_id == false) {
                this.type = 'a'
            }else if (this.$route.query.after_id == true){
                this.type = 'b'
            }

       },
        methods: {
            handleChange(index){
                var options_g=$("#test option:selected")
                this.options_g = options_g.text()
                if(this.selected === 6) {
                    this.other = true
                }else{
                    this.other = false
                }
            },
            canceled () {
                let data = {}
                const module = 'cancel_service'
                data.user_id = this.Local.getUserId()
                data.token = this.Local.getUserToken()
                data.lang = this.$i18n.locale
                data.sign = Signature.create(module, data.sub_time)
                data.goods_id = this.$route.query.goods_id
                data.order_sn = this.$route.params.order_sn
                this.$http.post(process.env.BASEURL + module, data)
                .then(function (resp) {
                    if (parseInt(resp.data.code) === 2000) {
                        this.$Message.success(this.$t('user_message_submit_success'))
                        this.openCanceled = false
                        this.$router.push({
                            name: 'Ongoing'
                        })
                        this.service_list = resp.data.data.service_list
                    }
                }.bind(this))
            },
            submit () {
                if(this.selected === 6){
                    if (!this.explanation) {
                        this.$Message.error(this.$t('user_message_please_input_recharge'))
                        return false
                    }
                }

                let data = {}
                const module = 'service'
                data.sub_time = Signature.timestamp()
                data.user_id = this.Local.getUserId()
                data.lang = this.$i18n.locale
                data.token = this.Local.getUserToken()
                data.sign = Signature.create(module, data.sub_time)
                data.order_sn = this.$route.params.order_sn
                data.goods_id = this.$route.query.goods_id
                data.type = this.serviceType
                data.status = this.expressStatus
                data.explanation = this.options_g + this.explanation
                this.$http.post(process.env.BASEURL + module, data)
                .then(function (resp) {
                    if (parseInt(resp.data.code) === 2000) {

                        this.$Message.success(this.$t('user_message_submit_success'))
                        this.type = 'b'
                        this.fetchData()
                        this.getRecharge()
                    }else{
                        this.$Message.error(resp.data.msg)
                    }
                }.bind(this))
            },
            getRecharge () {
                let data = {}
                const module = 'service_list'
                data.sub_time = Signature.timestamp()
                data.user_id = this.Local.getUserId()
                data.lang = this.$i18n.locale
                data.order_sn = this.$route.params.order_sn
                data.goods_id = this.$route.query.goods_id
                data.token = this.Local.getUserToken()
                data.sign = Signature.create(module, data.sub_time)
                this.$http.get(process.env.BASEURL + module, {
                    params: data
                })
                .then(function (resp) {
                    if (parseInt(resp.data.code) === 2000){
                        console.log(resp.data)
                        this.service_list = resp.data.data.service_list
                        this.process_result = resp.data.data.service_list.process_result
                        if(this.process_result){
                            this.process_result_yes = this.process_result
                        }
                        if (this.service_list) {
                            this.service_status = resp.data.data.service_list.service_status
                        }
                    }
                }.bind(this))
            },
            setServiceType (type) {
                this.serviceType = type
            },
            setExpressStatus (status) {
                this.expressStatus = status
            },
            fetchData () {
                let data = {}
                this.spinShow = true
                const module = 'find_detail'
                data.sub_time = Signature.timestamp()
                data.user_id = this.Local.getUserId()
                data.lang = this.$i18n.locale
                data.order_sn = this.$route.params.order_sn
                data.goods_id = this.$route.query.goods_id
                data.token = this.Local.getUserToken()
                data.sign = Signature.create(module, data.sub_time)
                this.$http.get(process.env.BASEURL + module, {
                    params: data
                })
                .then(function (resp) {
                    if (parseInt(resp.data.code) === 2000) {
                        this.spinShow = false
                        this.orders = resp.data.data.find_detail
                        console.log(this.orders[0].goods_price)
                    }
                }.bind(this))
            }
        }
    }
</script>
<style lang="scss" scoped>
    @import "../../scss/common";

    .aftermarket {
        padding: 0 20px;
        max-width: $body-width;
        margin: 80px auto;
        text-align: left;
        .order-sn {
            font-size: 16px;
            margin-bottom:10px;
        }
        .form-list {
            font-size: 16px;
        }
        .form-group {
            & > label {
                text-align: left;
                font-size: 16px;
                width: 150px;
                margin-top: 10px;
            }
            display: flex;
            align-items: flex-start;
        }
        .form-control {
            font-size: 16px;
            margin-top: 10px;
            & > label {
                margin-bottom: 10px;
            }

            textarea {
                background: #FFFFFF;
                border: 1px solid #99A9BF;
                border-radius: 4px;
                resize: none;
                outline: none;
                padding: 5px;
                &:focus, &:active {
                    border: 1px solid $primary;
                }
            }
        }
        .return_select{
            padding: 5px 0;
            border: 1px solid #495060;
        }
        .tips{
            max-width: 600px;
            color: #0084ff;
            margin-top: 20px;
        }
        .form-submit {
            text-align: left;
            margin-top: 20px;
        }
    }

    @media screen and (max-width: 768px) {
        .aftermarket {
            padding: 0 10px;
        }

    }
</style>



// WEBPACK FOOTER //
// Aftermarket.vue?43bdd476